import AccordionSection from './AccordionSection';

export { type AccordionSectionProps } from './AccordionSection';
export default AccordionSection;
